const attendanceStorage = {
  state: {
    singleStudentSelect: null
  },
  mutations: {
    SET_ATTENDANCE_SINGLE_STUDENT_ID_MUTUATION: (state, payload) => {
      state.singleStudentSelect = payload
    }
  },
  actions: {
    SET_ATTENDANCE_SINGLE_STUDENT_ID:({commit}, payload) => {
      commit('SET_ATTENDANCE_SINGLE_STUDENT_ID_MUTUATION', payload)
    }
  },
  getters: {
    get_attendance_single_student_id: (state) => {
      return state.singleStudentSelect
    }
  }
}
export default attendanceStorage
    